import { asuransiCicilanKreditMeta } from "../data/DataMetatags";
import Layout from "../components/Layout";
import NextHead from "../components/Seo/NextHead";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { AmanBreadcrumb } from "../data/DataBreadcrumb";
import { defBreadcrumb } from "../data/DataBreadcrumb";
import { ImageComponent } from "../components/UserInterface/ImageComponent";
import amanLogo from "../../public/static/images/svg/logo-aman.svg";
import Description from "../components/UserInterface/Description";
import { DataAman, CaraKlaimDataAman } from "../data/DataAman";
import {
  StepsComponent,
  TncComponent
} from "../components/UserInterface/StepsComponent";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import { SEOText } from "../components/UserInterface/SEOText";
import { AmanSEO } from "../data/DataSEO";
import React from "react";
import { NumberedText } from "../components/UserInterface/NumberedText";
import LayoutCenter from "../components/UserInterface/LayoutCenter";

const AsuransiCicilanKredit = (props) => {
  const {
    breadcrumb,
    title,
    description,
    path,
    DataAman,
    AmanBreadcrumb,
    AmanSEO
  } = props;
  const { howTo, tnc } = DataAman;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={AmanBreadcrumb} />
      <ImageComponent url={amanLogo} />
      <Description
        font="Roboto"
        width="820px"
        margin="0 16px"
        text="Aman merupakan Produk Proteksi yang memberikan perlindungan atas pembayaran cicilan  pembiayaan kamu dari risiko tak terduga, sehingga kamu dan keluarga tidak lagi terbebani.<br><br>Dengan memilih produk Aman, Penyedia Asuransi yang telah bekerjasama dengan Home Credit akan memberikan Pertanggungan berupa pelunasan pembiayaan atau pembayaran cicilan apabila terjadi risiko kecelakaan, cacat tetap total, atau meninggal dunia, terhadap diri Tertanggung dan/atau pasangan."
      />
      <StepsComponent
        img={howTo.img}
        title={howTo.title}
        subtitle={howTo.subtitle}
      />
      <TncComponent title={tnc.title} steps={tnc.steps} img={tnc.img} />
      <HeadingComponent headingText="Cara klaim AMAN" />
      <LayoutCenter mobileDirection>
        <NumberedText data={CaraKlaimDataAman} />
      </LayoutCenter>
      <HeadingComponent
        fontWeight="bold"
        headingText="Penyedia Proteksi AMAN"
      />
      <Description
        font="Roboto"
        margin="16px"
        width="660px"
        text="AMAN merupakan Produk Proteksi kolaborasi PT Home Credit Indonesia dengan PT Equity Life Indonesia dan PT Home Credit Indonesia dengan OONA Insurance (PT Asuransi Bina Dana Arta Tbk) yang berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK)"
      />
      <SEOText title={AmanSEO.title} text={AmanSEO.text} />
      <style jsx>{`
        .pdf-links {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 40px;
        }
      `}</style>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = asuransiCicilanKreditMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      title,
      description,
      path,
      DataAman,
      AmanBreadcrumb,
      AmanSEO
    }
  };
};

export default AsuransiCicilanKredit;
